import { render, staticRenderFns } from "./Investigativa.vue?vue&type=template&id=624704fc&"
import script from "./Investigativa.vue?vue&type=script&lang=js&"
export * from "./Investigativa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports